import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Analytics from '../../../utils/Analytics'

export default function KlaviyoEmbed({ klaviyoFormId, analyticsEvent, usePocForm = false }) {
  const pocFormId = 'YsSGDz' // PoC Form must exist in Klaviyo if used
  const idToUse = klaviyoFormId || pocFormId
  const formClass = `klaviyo-form-${idToUse}` // Follows pattern dictated by Klaviyo forms
  const gtmEvent = analyticsEvent || 'Clicked_Builder Klaviyo_Form CTA' // Corresponds to GTM event pattern in event -> Clicked Builder CTA

  useEffect(() => {
    const handleKlaviyoFormSubmit = (e) => {
      const { type, formId } = e?.detail
      if (type === 'submit' && formId === idToUse) {
        Analytics.track(gtmEvent)
      }
    }

    window.addEventListener('klaviyoForms', handleKlaviyoFormSubmit)

    return () => {
      window.removeEventListener('klaviyoForms', handleKlaviyoFormSubmit)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {!usePocForm && formClass.includes(pocFormId) && <div>Proof of Concept Form</div>}
      <div className={formClass} />
    </>
  )
}

KlaviyoEmbed.propTypes = {
  klaviyoFormId: PropTypes.string,
  analyticsEvent: PropTypes.string,
  usePocForm: PropTypes.bool,
}
